import React, { useEffect, useRef } from 'react';
import { get, debounce } from 'lodash';
import { Icon, Loader, FileUploader } from '../components/index';
import { ContainerSelectTransaction } from '../containers/index';
import { RouteWithSubRoutes } from '../Routers';
import { UserNavigation, Navigation } from '../partials/index';
import Avatar from '../assets/images/pic.png';
import { useAction, useSelect, useRequestSettings  } from '../hooks';
import { version } from '../../package.json';

const Main = ({ routes }) => {
  useRequestSettings()
  const goToTopRef = useRef()
  const mainContainerRef = useRef()
  const topBar = useRef()
  const getProfile = useAction('auth.getProfile')
  const updatePhoto = useAction('auth.updatePhoto')
  const getCheckMax = useAction('appointment.getCheckMax')
  const gettingProfile = useSelect('loading.isLoading', { type: 'auth.getProfile' })
  const updatingPhoto = useSelect('loading.isLoading', { type: 'auth.updatePhoto' })
  const user = useSelect('auth.user')
  const profile = useSelect('auth.profile')
  const isMax = useSelect('appointment.checkMax')

  useEffect(() => {
    getProfile()
    getCheckMax()
  // eslint-disable-next-line 
  }, [])

  useEffect(() => {
    const onScroll = debounce(
      (e) => {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
        if(topBar.current && scrollTop === 0){
          topBar.current.classList.remove('switch')
          goToTopRef.current.classList.add('hidden')
        }
  
        if(topBar.current && scrollTop > 180){
          topBar.current.classList.add('switch')
          goToTopRef.current.classList.remove('hidden')
        }
      }
    ,500)

    window.onscroll = onScroll
  }, [])

  const handleUploadPhoto = file => {
    updatePhoto({
      photo: file.cdnUrl
    })
  }

  const handleBackToTop = e => {
    e.preventDefault()
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }

  return (
    <>
    <div ref={topBar} className="top-bar">
      <div className="brand">
        <Icon.Logo className="h-16 w-16 my-2"/>
        
      </div>
      <div className="flex-grow flex items-center px-5">
        <b className="title font-medium text-primary hidden xl:flex lg:flex md:flex text-md xl:text-lg lg:text-sm">
          Land Transportation Franchising and Regulatory Board
        </b>
      </div>
      <UserNavigation />
    </div>
    <div ref={mainContainerRef} className="main-contaier">
      
      <div className="user-block ">
        <div className="content shadow-md">
          
          {!gettingProfile &&
            <div className="avatar relative bg-gray-300 flex items-center justify-center">
              <img alt="Avatar" className="rounded-full" src={get(profile, 'attributes.photo') || Avatar} />
              <FileUploader isLoading={updatingPhoto} onChange={handleUploadPhoto} className="absolute bg-primary rounded p-1" style={{ top: '80%', right: '8%' }}>
                <Icon.Camera/>
              </FileUploader>
            </div>
          }
          {gettingProfile && <Loader.Avatar />}
          
          <div className="info">
            {gettingProfile && (
              <div className="w-3/4">
                <Loader.UserEmail />
              </div>
            )}
            {!gettingProfile && (
              <>
                <b className="name">{`${get(profile, 'attributes.first_name')} ${get(profile, 'attributes.last_name')}`}</b>
                <span>{get(user, 'attributes.email')}</span>
              </>
            )}
          </div>
          <div>
            {(!isMax && +get(profile, 'attributes.total_service_units') !== 3) && <ContainerSelectTransaction />}
          </div>
        </div>
        <div className="navigation-container shadow-md">
          <Navigation />
        </div>
      </div>
      <div className="content">
        {routes.map(route => {
          return <RouteWithSubRoutes key={`mainRoutes${get(route, 'path')}`} {...route}/>
        })}
      </div>
    </div>
    <div className="w-full bg-primary px-main-side-gap flex-col py-20 mt-20">
      <div className="flex flex-col xl:flex-row  items-center"> 
        <div className="flex flex-col justify-center xl:justify-start lg:justify-start">
          <div className="flex flex-col xl:flex-row lg:flex-row space-y-2 xl:space-y-0 lg:space-y-0  space-x-0 xl:space-x-5 lg:space-x-2 items-center">
            <Icon.Logo className="h-16 w-16 my-2"/>
            <span className="font-medium text-white text-sm xl:text-lg lg:text-md">
              Land Transportation Franchising and Regulatory Board
            </span>
          </div>
          <div className="flex justify-center xl:justify-start lg:justify-start">
            <span className="text-white w-auto text-sm px-2 py-1 bg-info rounded text-black">Version {version}</span>
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center xl:justify-end lg:justify-end">
          <ul className="flex flex-col xl:flex-row lg:flex-row items-center space-y-2 xl:space-y-0 lg:space-y-0  space-x-0 xl:space-x-5 lg:space-x-2 text-white">
            <li className="text-center xl:text-left lg:text-left">About</li>
            <li className="text-center xl:text-left lg:text-left">How To's</li>
            <li className="text-center xl:text-left lg:text-left">FAQ's</li>
            <li className="text-center xl:text-left lg:text-left">Privacy Policy</li>
          </ul>
        </div>
      </div>
      <hr className="text-white my-10"/>
      <div className="flex flex-col xl:flex-row lg:flex-row"> 
        <div className="flex-1 flex justify-center">
          <span className="text-sm text-white">© 2020 LTFRB System. All Rights Reserved.</span>
        </div>
      </div>
    </div>
    <button ref={goToTopRef} onClick={handleBackToTop} className="fixed z-10 inset-x-1/2 " style={{ bottom: '1rem' }}>
      <Icon.BackToTop />
    </button>
    </>
  )
}

export default Main